import { useAuth } from "react-oidc-context";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { createFaq, editFaq, Faq, FaqApiPayload, fetchFaq, fetchFaqCats, fetchFaqs,  selectFaqStatus } from "../faqSlice";
import { clearAlert, infoAlert } from "../../shared/appSlice";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";

import { isFulfilled } from "@reduxjs/toolkit";
import { FaqEntryEditor } from "./FaqEntryEditor";

import styled from 'styled-components'
import { InputRow } from "../../shared/components/widgets/InputRow";
import { Loading } from "../../shared/components/Loading";
import { Alert } from "../../shared/components/Alert";
export const Wrapper = styled.article`
  display: grid;
  place-items: center;
  padding: 3rem;
  width: 100%;

`
/**
 * currently get a Warning on entry:  
 * "Can't call setState on a component that is not yet mounted. 
 * This is a no-op, but it might indicate a bug in your application. 
 * Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the i component.
 * 
 * also get on submit:
 * hook.js:608 Warning: A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components Error Component Stack
    at input (<anonymous>)
    at div (<anonymous>)
    at article (<anonymous>)
    at _c (InputRow.tsx:19:1)
    at form (<anonymous>)
    at article (<anonymous>)
    at FaqEntryForm (FaqEntryForm.tsx:46:1)
 * 
 * apparently this is occuring because of "const { id } = useParams();"
 * @returns 
 */
export const FaqEntryForm = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const appstate = useAppSelector(state => state.appstate);
  const faqstate = useAppSelector(state => state.faqstate);
  const faqStatus = useAppSelector(selectFaqStatus)
  const auth = useAuth();
  const [catsInUseElsewhere, setCatsInUseElsewhere] = useState<string[]>([]);

  const { control, handleSubmit, setValue, formState: { isSubmitSuccessful } } = useForm<Faq>({ defaultValues: faqstate.faq });

  

  useEffect(() => {

    const getApiDataForEdit = async () => {
      const action = await dispatch(fetchFaq({id: id} as FaqApiPayload));
      if (isFulfilled(action)) {
        await dispatch(fetchFaqCats('general'));
      }
      setCatsInUseElsewhere(faqstate.generalCats);

    }

    const getApiDataForAdd = async () => {
      console.log('entering add faq')
      const action = await dispatch(fetchFaqCats('general'));
      if (isFulfilled(action)) {
        setCatsInUseElsewhere(faqstate.generalCats);
      }
    }

    dispatch(clearAlert());
    if (id) {
      getApiDataForEdit();
    } else {
      getApiDataForAdd();
    }
  }, [dispatch])


  const onSubmit: SubmitHandler<Faq> = async (data: Faq) => {
    console.log(data)

    data.faqOrder = faqstate.faqOrderValue;

    if (data.id) {

      const payload: FaqApiPayload = {accessToken: auth.user?.access_token as string, id: data.id, faq: data}

      const action1 = await dispatch(editFaq(payload))
      if (isFulfilled(action1)) {
        dispatch(infoAlert('faq updated'));
        const action2 = await dispatch(fetchFaqs())
        if(isFulfilled(action2)) {
          navigate('/faqs')
        }
      }

    } else {
      data.author = auth.user?.profile.preferred_username as string || auth.user?.profile.email as string;
      data.category = data.category ? data.category : 'any';
      data.audience = 'general'
      const payload: FaqApiPayload = {accessToken: auth.user?.access_token as string, id: null, faq: data}

      const action1 = await dispatch(createFaq(payload))
      if (isFulfilled(action1)) {
        dispatch(infoAlert('faq created'));
        const action2 = await dispatch(fetchFaqs())
                // should filter and sort here

        if(isFulfilled(action2)) {
          navigate('/faqs')
        }
      }
    }
  }

  return (
    faqStatus === 'pending' ? (
      <Loading centre />
    ) : (
      <Wrapper>
        {appstate.showAlert && <Alert />}


        <form className="lr-padded-container" onSubmit={handleSubmit(onSubmit)}>
          {/* <Controller name="category" control={control} render={({ field, formState: {errors} }) => 
            <FaqInputRow {...field} cats={catsInUseElsewhere} value={field.value} setValue={setValue} error={errors.category?.message} label="Category" />} /> */}

          <Controller name="question" rules={{ required: 'question is required' }} control={control} render={({ field, formState: {errors} }) => 
            <InputRow {...field} value={field.value} error={errors.question?.message} type="input" className="form-input" label="Question *" />} /> 

          <Controller
            name='answer'
            control={control}
            render={({ field: {onChange, ...field }, formState: {errors} }) => (
              // Debouncing is a programming technique that delays the execution of a function until a specific amount of time has passed since the last event
              <FaqEntryEditor {...field} label="Answer *" value={field.value} setValue={setValue} onChange={onChange} error={errors.answer?.message}/>
            )}
/> 
          <button
            type='submit'
            className='btn btn-go'
            >
            Submit
          </button>
        </form>
        
      </Wrapper>
    )

  );
}